import React from 'react'
export const SectionalAlertSuccessIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" className='flex-shrink-0 overflow-visible' viewBox="0 0 18 18">
            <title>Success Icon</title>
            <path id="exclamation-circle" d="M26,17a9,9,0,1,1-9-9A9,9,0,0,1,26,17Zm-5.514,6.471c0,.922-4.408-1.317-3.486-1.317.259,0,1.206.25,1.669,0,.315-.125,0-1.006,0-1.669C18.669,19.562,20.486,22.549,20.486,23.471Zm-4.078-4.431-3.29-2.512c.013.231-1.438,2.013-1.207,2.013l4.317,3.13c.119.095.76.715.773.484L22.438,14.6a5.607,5.607,0,0,0-1.954-1.457l-.372.549-.27.4Z" transform="translate(-8 -8)" fill="#060" />
        </svg>
    )
}